export const environment = {
  production: true,
  envPrefix: 'qa',
  project: 'qa-companion',
  apiUrl: 'https://api.revenue.qarbcompanion.com',
  auth: {
    clientId: '4d3d8045-ab2f-461a-b575-51fed6bb112a', // This is your client ID
    authority: 'https://login.microsoftonline.com/4311f7b0-1d4f-429a-b2da-ec3498aded90', // This is your tenant ID
    redirectUri: 'https://revenue.qarbcompanion.com/'// This is your redirect URI
  },
};
